export function slugForCustomRestaurantHost(hostname: string | null | undefined) {
  if (!hostname) return null

  const host = hostname.trim().toLowerCase().replace(/\.$/, '').split(':')[0]
  if (host === 'wasabi.am' || host === 'www.wasabi.am') {
    return 'wasabi'
  }

  return null
}

export function getRestaurantSlugFromHost(query?: Record<string, any>) {
  const config = useRuntimeConfig()
  const appEnv = config.public.appEnv
  const url = useRequestURL()
  const routeSlug = Array.isArray(query?.slug) ? query.slug[0] : query?.slug
  const querySlug = url.searchParams.get('slug') || (routeSlug ? String(routeSlug) : null)

  if (appEnv !== 'prod' && querySlug) {
    return String(querySlug)
  }

  const host = url.hostname
  if (!host) return null

  const customSlug = slugForCustomRestaurantHost(host)
  if (customSlug) return customSlug

  const parts = host.split('.')
  if (parts.length === 3) {
    return parts[0]
  }

  return null
}

export function landingSlugQuery(slug?: string | null) {
  const config = useRuntimeConfig()
  if (config.public.appEnv === 'prod') return undefined
  if (slugForCustomRestaurantHost(useRequestURL().hostname)) return undefined
  if (!slug) return undefined
  return { slug: String(slug) }
}
